export enum ColumnsPostTradingExercisesEnum {
	option = 'option',
	options = 'options',
	stocks = 'stocks',
	sum = 'sum',
	price = 'price',
	event = 'event',
	date = 'date',
}
